import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import analytics from '../../js/analytics';
import useBreakpoints from 'hooks/use-breakpoints';
import Modal from 'components/modal';
import ContentContainer from 'components/content-container';
import NotifyMeForm from 'components/notify-me-form';

const NotifyMeModal = ({
  buttonLabel,
  formButtonLabel,
  productName,
  productCategory,
  productBrand,
  outOfStockText,
  emailInputLabel,
  emailInputPlaceholder,
  cancelLabel,
  form,
  itemIdFieldNameForAnalytics,
  closeLabel,
  isOpen,
  setIsOpen,
  selectedProductValues
}) => {
  const { isTablet } = useBreakpoints(true, true);
  const [responseMessage, setResponseMessage] = useState('');
  const [formKey, setFormKey] = useState(0);
  const ModalContentWrapper = isTablet ? 'div' : ContentContainer;
  const modalId = 'notify-me-modal';

  useEffect(() => {
    if (!isOpen) {
      setResponseMessage('');
      setFormKey(prevKey => prevKey + 1);
    }
  }, [isOpen]);

  const onResponse = response => {
    setResponseMessage(response.messageToUser);

    if (response.isRegistered) {
      const eventData = {
        event: 'stock_notification',
        items: [
          {
            item_id: selectedProductValues[itemIdFieldNameForAnalytics],
            item_name: productName,
            item_category: productCategory,
            item_brand: productBrand
          }
        ]
      };

      analytics.send(eventData);
    }
  };

  return (
    <Modal
      animate={false}
      className="notify-me-modal"
      containerClassName="notify-me-modal__inner"
      contentClassName="notify-me-modal__content"
      id={modalId}
      isVisible={isOpen}
      hide={() => setIsOpen(false)}
      closeButtonText={closeLabel}
      closeButtonClassName="notify-me-modal__close-btn"
    >
      <ModalContentWrapper>
        <h2 className="notify-me-modal__title">{productName}</h2>
        {outOfStockText && (
          <span className="notify-me-modal__out-of-stock-text">
            {outOfStockText}
          </span>
        )}
        <div className="notify-me-modal__content-wrapper">
          {responseMessage ? (
            <p className="notify-me-modal__response-message">
              {responseMessage}
            </p>
          ) : (
            form && (
              <NotifyMeForm
                {...form}
                formKey={formKey}
                emailInputLabel={emailInputLabel}
                emailInputPlaceholder={emailInputPlaceholder}
                formButtonLabel={formButtonLabel || buttonLabel}
                cancelLabel={cancelLabel}
                selectedProductValues={selectedProductValues}
                onResponse={onResponse}
                onCancel={() => setIsOpen(false)}
              />
            )
          )}
        </div>
      </ModalContentWrapper>
    </Modal>
  );
};

NotifyMeModal.propTypes = {
  buttonLabel: PropTypes.string,
  formButtonLabel: PropTypes.string,
  productName: PropTypes.string,
  productCategory: PropTypes.string,
  productBrand: PropTypes.string,
  outOfStockText: PropTypes.string,
  emailInputLabel: PropTypes.string,
  emailInputPlaceholder: PropTypes.string,
  form: PropTypes.exact(NotifyMeForm.propTypes),
  cancelLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  itemIdFieldNameForAnalytics: PropTypes.string,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  selectedProductValues: PropTypes.object
};

NotifyMeModal.propTypesMeta = {
  productName: 'exclude',
  productCategory: 'exclude',
  productBrand: 'exclude',
  isOpen: 'exclude',
  setIsOpen: 'exclude',
  selectedProductValues: 'exclude'
};

export default NotifyMeModal;
